import _ from 'underscore';
import messageTemplate from 'text!./templates/message-template.html';

var _showMessage = function _showMessage($filter, $modal, title, message, description, actionObj, iconClass, templateStr, showCancel, options, cancelBtnLabel, radioOptions, transcludedContent, checkboxOptions) {
    var opts = {
        template: templateStr,
        backdrop: true,
        controller: 'ModalController',
        resolve: {
            model: function model() {
                return {
                    title: title,
                    message: message,
                    description: description,
                    showCancelBtn: showCancel,
                    keyboard: 'false',
                    iconClass: iconClass,
                    cancelBtnLabel: cancelBtnLabel || $filter('translate')('platform.modal.ModalService.Close'),
                    action: actionObj,
                    radioOptions: radioOptions,
                    checkboxOptions: checkboxOptions
                };
            },
            stateProps: function stateProps() {
                return {};
            }
        },
        transcludedContent: transcludedContent
    };
    if (options) {
        angular.extend(opts, options);
    }

    return $modal.open(opts);
};

export default ['$modal', '$filter', function ($modal, $filter) {
    return {
        showInfo: function showInfo(title, message, description, actionLabel, actionBtnClass) {
            var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
            };

            return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageInformationIcon', messageTemplate);
        },

        showEmail: function showEmail(title, message, description, actionLabel, actionBtnClass) {
            var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
            };

            return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageEmailIcon', messageTemplate);
        },

        showConfirm: function showConfirm(title, message, description, actionLabel, actionBtnClass, cancelLabel, radioOptions) {
            var actionProperties = {
                label: actionLabel,
                btnClass: actionBtnClass || 'gw-btn-primary'
            };
            cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
            var opts = {
                keyboard: false
            };
            return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageQuestionIcon', messageTemplate, true, opts, cancelLabel, radioOptions);
        },

        showWarning: function showWarning(title, message, description, actionLabel, actionBtnClass, cancelLabel, radioOptions, transcludedContent, showCancelButton, checkboxOptions) {
            var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
                btnClass: actionBtnClass || 'gw-btn-primary'
            };
            var opts = {
                keyboard: false
            };
            cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
            showCancelButton = showCancelButton !== undefined ? showCancelButton : true;
            return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageWarningIcon', messageTemplate, showCancelButton, opts, cancelLabel, radioOptions, transcludedContent, checkboxOptions);
        },

        showError: function showError(title, message, description, actionLabel, actionBtnClass) {
            var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.Close'),
                btnClass: actionBtnClass
            };
            return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageErrorIcon', messageTemplate);
        },

        showSuccess: function showSuccess(title, message, description, actionLabel, actionBtnClass) {
            var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
                btnClass: actionBtnClass || 'gw-btn-primary'
            };
            return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageSuccessIcon', messageTemplate);
        },

        showProgressDialog: function showProgressDialog() {
            throw new Error('Progress dialog is deprecated in favour of gw-loader directive');
        },

        showTwoPromiseProgressDialog: function showTwoPromiseProgressDialog() {
            throw new Error('Two Promise Progress Dialog is deprecated in favour of gw-loader directive');
        },

        showFullScreenPopup: function showFullScreenPopup(template, _stateProps, options) {
            var opts = {
                template: template,
                controller: 'ModalController',
                fullScreen: true,
                resolve: {
                    model: function model() {
                        return {};
                    },
                    stateProps: function stateProps() {
                        return _stateProps;
                    }
                }
            };

            if (options) {
                angular.extend(opts, options);
            }

            return $modal.open(opts);
        },

        /**
         * Shows a simple dialog composed of external template and controller components. It allows user to create
         * new dialog using just a simple functions and not a separate "controller" instance (which is anyway
         * just a same collection of functions). Not recommended for a complex scenarios (use separate controller
         * instead).
         *
         * @param {String} template data rendering template.
         * @param {undefined|Object} data simple scope data. This map is copied to scope "as-is". Useful to provide initial (or data)
         * model values, some basic (non-scope) functions.
         * @param {undefined|Object} scopeFunctions functions to bind to a scope. This map should have only a functions as it's values.
         * Each that function should receive a $scope argument as it's first value. This functions are bound
         * (partially applied) to a context. Result of that partial application is bound to the scope using
         * original function's key.
         * <p> Example. If we have a pair 'someFunction' : function($scope, a, b, c) {}, resulting scope will have
         * a function 'someFunction': function(a, b, c) {};
         * @param {undefined|Function} initializer optional function to invoke on the scope. This function may install watches,
         * binding, etc...
         * @param {undefined|Object} opts  Extra modal options
         *
         * @returns {Object}
         */
        'showSimpleDialog': function showSimpleDialog(template, data, scopeFunctions, initializer) {
            var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            return $modal.open(angular.extend({
                template: template,
                backdrop: true,
                controller: ['$scope', function ($scope) {
                    var key = void 0;
                    if (data) {
                        for (key in data) {
                            if (data.hasOwnProperty(key)) {
                                $scope[key] = data[key];
                            }
                        }
                    }

                    if (scopeFunctions) {
                        for (key in scopeFunctions) {
                            if (scopeFunctions.hasOwnProperty(key)) {
                                $scope[key] = _.partial(scopeFunctions[key], $scope);
                            }
                        }
                    }

                    if (initializer) {
                        initializer($scope);
                    }
                }]
            }, opts));
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/modal/ModalService.js
// module id = 1129
// module chunks = 0